
export const STATIC_IMAGES = {
  VIDAL_LOGO_DARK: 'https://vidalstaticassetsdev.blob.core.windows.net/cms-uat/assets/vidal_nav_logo_dark_a7b12eb90e.webp',
  VIDAL_LOGO_LIGHT: 'https://vidalstaticassetsdev.blob.core.windows.net/cms-uat/assets/vidal_nav_logo_light_eda60a98c3.webp',
  VIDAL_LOGO_BACKUP: 'https://vidalstaticassetsdev.blob.core.windows.net/cms-uat/assets/logo_backup_f990143952.webp',

  VIDAL_LOGO_BG: 'https://vidalstaticassetsdev.blob.core.windows.net/cms-uat/assets/vidal_logo_bg_134831dc1a.webp',
  ECARD_SPLASH: 'https://vidalstaticassetsdev.blob.core.windows.net/cms-uat/assets/ecard_splash_e31447fa1a.webp',

  PDF_ICON: 'https://vidalstaticassetsdev.blob.core.windows.net/cms-uat/assets/pdf_icon_f099204ce7.webp',
  IMAGE_ICON: 'https://vidalstaticassetsdev.blob.core.windows.net/cms-uat/assets/image_icon_cad8eb3976.webp',

  PROVIDER_NETWORK: 'https://vidalstaticassetsdev.blob.core.windows.net/cms-uat/assets/provider_network_d959327c8b.webp',
  CREDIT_CARD: 'https://vidalstaticassetsdev.blob.core.windows.net/cms-uat/assets/credit_card_2c07853258.webp',
  TREND_ARROW: 'https://vidalstaticassetsdev.blob.core.windows.net/cms-uat/assets/trend_arrow_5ace9c927f.webp',

  SPECIAL_MIS: 'https://vidalstaticassetsdev.blob.core.windows.net/cms-uat/assets/container_image_482a1b32e4.webp'
}
